//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  const discover = angular.module('curalate');

  discover.component('contentSourceBadge', {
    template: require('@legacy-components/common/content-source-badge/content-source-badge.html'),
    bindings: {
      avatarUrl: '<',
      maintitle: '<',
      subtitle: '<',
      sourceType: '<',
      dependency: '<',
      metadata: '<?',
      disableLink: '<?',
      onClick: '&?',
      hrefLink: '<?',
      followers: '<',
      hideUploaded: '@?',
      routeToExternal: '<',
      network: '<?',
    },
    controller: [
      'ContentSourceTypes',
      function(ContentSourceTypes) {
        const self = this;

        self.SOURCE_TYPE_UPLOAD = ContentSourceTypes.UPLOAD;

        this.$onInit = function() {
          switch (self.sourceType) {
            case ContentSourceTypes.USER: {
              self.sourceIcon = require('@images/icons/user.svg');
              break;
            }
            case ContentSourceTypes.HASHTAG: {
              self.sourceIcon = require('@images/icons/hashtag-2.svg');
              break;
            }
            case ContentSourceTypes.UPLOAD: {
              self.titleFirstLetter = _(self).safeGet('maintitle.0');
              self.emailHash = _(self).safeGet('metadata.emailHash');
              break;
            }
            default: {
                            // no-op
            }
          }
        };
      },
    ],
  });
})();
